export default __webpack_public_path__ + "static/media/chessPieces.e155dff1.webp";